import React from 'react'
import { Box, Button, Container, Typography } from '@mui/material'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import errorImage from '../assets/sad_cat.png'

const ErrorPage: React.FC = () => {
    const { t } = useTranslation()
    const location = useLocation()
    const message = location.state?.message

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <img src={errorImage} alt="" style={{ width: '60px', opacity: 0.6 }} />
                <Typography component="h1" variant="h4" sx={{ mt: 2 }}>
                    {t('errors.error_page.title')}
                </Typography>
                <Typography variant="body1" sx={{ mt: 1, textAlign: 'center' }}>
                    {message ?? t('errors.error_page.default_message')}
                </Typography>
                <Button component={Link} to="/" sx={{ mt: 3, mb: 2 }}>
                    {t('errors.error_page.back_home')}
                </Button>
            </Box>
        </Container>
    )
}

export default ErrorPage
